export default __webpack_public_path__ + "f16e206cfd98e4b107dd05c7c16a3aa2.jpg";